import { Id } from "PFCore/types";
import { RefObject, useEffect } from "react";

import { getListItemId } from "./list.utils";

type UseAutoScrollToSelectedProps = {
  listRef: RefObject<HTMLUListElement | null>;
  multiple?: boolean;
  selectedIds: Id[];
  listId: string;
};

export const useAutoScrollToSelected = ({
  listRef,
  multiple,
  selectedIds,
  listId
}: UseAutoScrollToSelectedProps) => {
  useEffect(() => {
    if (!multiple && selectedIds.length === 1 && listRef.current) {
      const selectedId = selectedIds[0];
      const selectedElement = listRef.current.querySelector(
        `[id="${getListItemId(listId, String(selectedId))}"]`
      );

      if (selectedElement) {
        selectedElement.scrollIntoView({ block: "center", behavior: "auto", container: "nearest" } as any); // container arg is missing in type but exists in docs
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
